const s = (e) => {
  const t = {};
  return Object.keys(e).forEach((o) => {
    if (o !== "cmsEdit") {
      const p = o;
      let c = e[o]?.value;
      const r = e[o]?.textReplacementValues;
      c && r && Object.keys(r).forEach((i) => {
        const n = r[i], a = new RegExp(`{{${i}}}`, "g");
        c = c.replace(a, n || "");
      }), t[p] = c;
    }
  }), t;
}, l = (e) => s(e), y = (e) => Object.prototype.hasOwnProperty.call(e, "content") || Object.prototype.hasOwnProperty.call(e, "areas") || Object.prototype.hasOwnProperty.call(e, "areaGridColumns") || Object.prototype.hasOwnProperty.call(e, "columnSpan") || Object.prototype.hasOwnProperty.call(e, "rowSpan") || Object.prototype.hasOwnProperty.call(e, "cultures") || Object.prototype.hasOwnProperty.call(e, "contentType") || Object.prototype.hasOwnProperty.call(e, "properties") || Object.prototype.hasOwnProperty.call(e, "updateDate") || Object.prototype.hasOwnProperty.call(e, "route") || Object.prototype.hasOwnProperty.call(e, "settings") ? "delivery" : "dictionary", O = (e) => {
  let t = {
    backofficeDisplayName: "",
    editLink: "",
    itemId: ""
  };
  if (e.cmsEdit)
    return t = {
      backofficeDisplayName: e.cmsEdit.backofficeDisplayName,
      editLink: e.cmsEdit.editLink,
      itemId: e.cmsEdit.itemId
    }, t;
  const o = Object.keys(e);
  for (let p = 0; p < o.length; p += 1) {
    const c = o[p], r = e[c];
    if (r?.cmsEdit) {
      t = {
        backofficeDisplayName: r.cmsEdit.backofficeDisplayName,
        editLink: r.cmsEdit.editLink,
        itemId: r.cmsEdit.itemId
      };
      break;
    }
  }
  return t;
};
export {
  y as checkApiFormat,
  s as convertDictionaryToProps,
  l as dictionaryApiParser,
  O as getBackofficeLink
};
